import SecureLS from 'secure-ls';
import config from 'config';
import nodeConfig from 'configs/nodeConfig';

const CLIENT_CONFIGURATION_CACHE = 'hotelConfigCache';
const { env = 'development' } = nodeConfig;
const { b2c = {} } = config;

class clientConfigHelper {
    constructor() {
        let prop;
        if (env == 'development') {
            prop = {
                encodingType: '',
                isCompression: false
            };
        } else {
            prop = {
                encodingType: 'des',
                isCompression: true,
                encryptionSecret: 'tgs'
            };
        }
        this.secureLS = new SecureLS(prop);
        this.config = {};
    }

    encryptJSONAndSave = (key, json) => {
        this.secureLS.set(key, json);
    }

    decryptAndGet = (key) => {
        return this.secureLS.get(key);
    }

    fetchConfigFromLS = () => {
        const { timeLabel = '', content = '' } = this.decryptAndGet(CLIENT_CONFIGURATION_CACHE);
        return content;
    }

    getConfig = () => {
        const { timeLabel = '', content = config } = this.decryptAndGet(CLIENT_CONFIGURATION_CACHE);
        const { b2c = {} } = config;
        const { b2c: b2cContent = {} } = content;
        return process.env.CLIENT_TYPE === 'b2c' ? { ...config, ...content, ...b2c, ...b2cContent } : { ...config, ...content, };
    }


    isTokenChanged = (keys = [], prevTokens = {}, newTokens = {}) => {
        return keys.filter((key) => {
            return prevTokens[key] != newTokens[key];
        });
    }

}

const helper = new clientConfigHelper();

Object.freeze(helper);

export default helper;